export const appVersion = { version: '2837956' };
